import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-833d1026"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "docs" }
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { class: "docs__icon" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#filled-file-icon--sprite" })
], -1))
const _hoisted_5 = { class: "docs__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommonLoader = _resolveComponent("CommonLoader")!
  const _component_CommonButtonPrimary = _resolveComponent("CommonButtonPrimary")!
  const _component_CommonModal = _resolveComponent("CommonModal")!

  return (_openBlock(), _createBlock(_component_CommonModal, {
    title: _ctx.$t('Dear users!'),
    visible: _ctx.needAccept,
    hideClose: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "form",
        onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onAccept && _ctx.onAccept(...args)), ["prevent"]))
      }, [
        _createVNode(_component_CommonLoader, {
          isPlaceholder: "",
          active: _ctx.state === 'PENDING'
        }, null, 8, ["active"]),
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentContent, (item) => {
            return (_openBlock(), _createElementBlock("p", {
              class: "content__item",
              key: item
            }, _toDisplayString(item), 1))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.docsData, (doc) => {
            return (_openBlock(), _createElementBlock("a", {
              class: "docs__item",
              key: doc.link,
              href: doc.link,
              target: "_blank"
            }, [
              _hoisted_4,
              _createElementVNode("span", _hoisted_5, _toDisplayString(doc.sourceDesc), 1)
            ], 8, _hoisted_3))
          }), 128))
        ]),
        _createVNode(_component_CommonButtonPrimary, { type: "submit" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("Accept")), 1)
          ]),
          _: 1
        })
      ], 32)
    ]),
    _: 1
  }, 8, ["title", "visible"]))
}